import { getTenantHasBuildingsKey } from '../store';
import { removeItem } from 'owa-local-storage';

export function deleteTenantPlacesCache(): void {
    removeItem(window, getTenantHasBuildingsKey());
}
